module.exports = __webpack_public_path__ + "static/ac-interview.5243f760.png";